import { useState } from "react";
import { toastAlert } from "../../utils/AlertContext";
import { deleteWitnessURL } from "../../utils/ConstantsURL";

export function useDeleteWitness(token) {
  const [loading, setLoading] = useState(false);

  const deleteWitness = async (id_testigo) => {
    setLoading(true);
    try {
      const res = await fetch(deleteWitnessURL(id_testigo), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!res.ok) {
        toastAlert("Error al eliminar el testigo", "error");
        return false;
      }
      toastAlert("Testigo eliminado correctamente", "success");
      return true;
    } catch (err) {
      toastAlert("Error al eliminar el testigo: " + err.message, "error");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return { loading, deleteWitness };
}
